import { render, staticRenderFns } from "./podcast-item.vue?vue&type=template&id=4180399c&"
import script from "./podcast-item.vue?vue&type=script&lang=js&"
export * from "./podcast-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4180399c', component.options)
    } else {
      api.reload('4180399c', component.options)
    }
    module.hot.accept("./podcast-item.vue?vue&type=template&id=4180399c&", function () {
      api.rerender('4180399c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/components/listing/podcast-item.vue"
export default component.exports